
import { useRouter } from "vue-router";
import {defineComponent, ref, inject, onMounted} from "vue";
import AddRoutes from "@/router/asyncRouter";
import { storeRouter } from "@/store/Router";
import { storeUser } from "@/store/User";
import { postLogin,privilegeList } from "@/api/http";
export default defineComponent({
    name: "Login",
    setup() {
        // let loginStatusChange:any =  inject('loginStatusChange');
        // loginStatusChange(false)
        let form = ref({
                account: "",
                password: "",
            }),
            rules = ref({
                account: [
                    { required: true, message: "请输入账号", trigger: "blur" },
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                ],
            }),
            formRef = ref(null),
            Router = useRouter(),
			
		
            submitForm = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid)  return
					postLogin({type:2,url:window.location.href,...form.value}).then((res: any) => {
						if (res.status != 200)  return 
                        // 添加动态路由，项目未正式上线前需注释这两段代码，上线前除删除路由表内所有需要权限的路由，再执行动态添加路由，完成权限控制功能
						// storeRouter.setRouter(res.content.privilege);
						// AddRoutes(storeRouter.getRouter());
						localStorage.setItem("user_info",JSON.stringify(res.content.info));
						localStorage.setItem("privilegeRouters",JSON.stringify(res.content.privilege));
						localStorage.setItem("ACCESS_TOKEN", res.content.info.token);
						storeUser.setUser(res.content.info)
                        // Router.push('/')
						// Router.push(res.content.privilege[0].redirect);
						// 从权限管理列表接口获取路由权限
						// privilegeList({type:1}).then((res:any) =>{
						// 	localStorage.setItem("privilegeRouters",JSON.stringify(res.content.list));
						// });
						window.location.href = res.content.info.url
					});
                    
                });
            },
        keyupSubmit = ()=>{
            document.onkeydown = (e) => {
                let _key = (window.event as any).keyCode;
                if (_key === 13) {
                    submitForm();
                }
            };
        };
        onMounted(()=>{
            keyupSubmit()
        });
        return {
            form,
            rules,
            formRef,
            submitForm,
        };
    },
});
